import type { QueryRequestResult } from '../../../slices/DataSourceControllerSlice/types';

export const getCombinedDataSourceState = ({
  dataSourcesState,
  dataSourceMethods,
}: {
  dataSourcesState: Record<string, QueryRequestResult | undefined>;
  dataSourceMethods: Record<string, unknown>;
}) => {
  const combinedDataSourceState: Record<string, unknown> = { ...dataSourcesState };
  const keys = Object.keys(dataSourcesState);
  const keysLength = keys.length;

  for (let i = 0; i < keysLength; i++) {
    const dataSourceId = keys[i];
    combinedDataSourceState[dataSourceId] = {
      ...(combinedDataSourceState[dataSourceId] ?? {}),
      ...(dataSourceMethods[dataSourceId] ?? {}),
    };
  }

  return combinedDataSourceState;
};
